module.exports = __webpack_public_path__ + "static/media/ic_share.d0cd51a9.svg";